export default {
  bind(el, binding, vnode) {
    // eslint-disable-next-line func-names
    el.clickOutsideEvent = function (event) {
      // Check if click was outside of element
      if (!(el === event.target || el.contains(event.target))) {
        // Call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };

    setTimeout(() => {
      document.addEventListener('click', el.clickOutsideEvent);
    }, 0);
  },
  unbind(el) {
    document.removeEventListener('click', el.clickOutsideEvent);
  },
};
